module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/share-ef120d7523235ff75f7752abeeceda84.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/share.svg
// module id = 1595
// module chunks = 0